"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PreviewPill_1 = __importStar(require("../../PreviewPill"));
const common_utils_1 = require("@zapier/common-utils");
const PlaceholderColors_1 = __importDefault(require("../../PrettyText/PlaceholderColors"));
const tokenizeTaggedText_1 = __importDefault(require("../../PrettyText/utils/tokenizeTaggedText"));
const codemirror_overrides_1 = require("../../../styles/codemirror-overrides");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        whiteSpace: 'pre-wrap',
        lineHeight: '24px',
        maxHeight: codemirror_overrides_1.maxHeight,
        overflow: 'auto',
    },
    placeholder: (isErrored) => [
        {
            color: PlaceholderColors_1.default.default,
            ':hover': {
                color: PlaceholderColors_1.default.focusedOrHovered,
            },
        },
        isErrored &&
            common_utils_1.withModifier('errored', {
                color: PlaceholderColors_1.default.error,
            }),
    ],
});
const ReadOnlyPrettyText = (props) => {
    if (props.placeholder && !props.initialValue) {
        return (common_utils_1.isolateComponent("div", { css: [Styles.root, Styles.placeholder(props.isErrored)] }, props.placeholder));
    }
    const tokens = tokenizeTaggedText_1.default(props.initialValue);
    const nodes = tokens.map((part, i) => {
        if (part.type === 'tag') {
            const previewPillProps = PreviewPill_1.getPreviewPillProps(props.choiceGroups, part.value);
            return common_utils_1.isolateComponent(PreviewPill_1.default, Object.assign({ key: i }, previewPillProps));
        }
        return common_utils_1.isolateComponent("span", { key: i }, part.value);
    });
    return common_utils_1.isolateComponent("div", { css: Styles.root }, nodes);
};
exports.default = ReadOnlyPrettyText;
